/* QuickPlate consolidated cart-add module
 *
 * Handles all "Haluan tämän" / "I want it" buttons across the page:
 *   - sections/collage.liquid (qp_iwant_btn capture, when template is quickplate)
 *   - sections/quickplate-ugc-slideshow.liquid (UGC ATC pattern)
 *   - sections/quickplate-atc.liquid (standalone ATC, keeps trigger reveal)
 *   - templates/product.quickplate.json liquid_iwant_rt block (rich-text inline)
 *   - snippets/custom-trust-text.liquid (dynamic injection on collage)
 *
 * Wires components by data-attributes so liquid stays minimal.
 * Auto-initialises on DOMContentLoaded and on Shopify theme:section:load.
 */
(function () {
  'use strict';

  // Idempotency guard: this file is now loaded globally (layout/theme.liquid) AND
  // by sections/quickplate-atc.liquid on the product page. Bail if already initialised.
  if (window.QuickPlateCart) return;

  var DEFAULT_VARIANT_ID = 48283972993356; // QuickPlate variant
  var ENDPOINT = '/cart/add.js';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /**
   * Swap the cart drawer panel content from a Section Rendering API HTML
   * string and sync all cart-count badges.
   */
  function renderDrawerSection(html, sectionId) {
    try {
      var parser = new DOMParser();
      var newDoc = parser.parseFromString(html, 'text/html');
      var panelId = 'MiniCart-' + sectionId;
      var newPanel = newDoc.getElementById(panelId);
      var curPanel = document.getElementById(panelId);
      if (newPanel && curPanel) {
        curPanel.innerHTML = newPanel.innerHTML;
      } else {
        var newFlex = newDoc.querySelector('#CartDrawer .drawer__panel .flex.flex-col.h-full');
        var curFlex = document.querySelector('#CartDrawer .drawer__panel .flex.flex-col.h-full');
        if (newFlex && curFlex) curFlex.innerHTML = newFlex.innerHTML;
      }
      var newCount = newDoc.querySelector('cart-count');
      if (newCount) {
        $$('cart-count').forEach(function (el) {
          el.textContent = newCount.textContent;
          el.removeAttribute('hidden');
        });
      } else {
        $$('cart-count').forEach(function (el) { el.removeAttribute('hidden'); });
      }
    } catch (e) { /* ignore */ }
  }

  /**
   * Add a quantity of a variant to the cart and refresh the cart drawer.
   * Returns a Promise that resolves when done.
   */
  function addToCart(qty, variantId) {
    var drawerEl = document.getElementById('CartDrawer');
    var drawerSectionId = drawerEl ? drawerEl.dataset.sectionId : null;
    var body = { items: [{ id: variantId || DEFAULT_VARIANT_ID, quantity: qty }] };
    if (drawerSectionId) {
      body.sections = drawerSectionId;
      body.sections_url = window.location.pathname;
    }

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // Refresh cart drawer panel from sections payload
        if (data.sections && drawerSectionId && data.sections[drawerSectionId]) {
          renderDrawerSection(data.sections[drawerSectionId], drawerSectionId);
        } else {
          $$('cart-count').forEach(function (el) { el.removeAttribute('hidden'); });
        }
        // Open cart drawer
        var cartBtn = document.querySelector('[aria-controls="CartDrawer"]');
        if (cartBtn) cartBtn.click();
        return data;
      });
  }

  /**
   * Initialise an ATC component within a wrapper element.
   *
   * Expected DOM:
   *   wrapper (data-qp-atc)
   *     .qp-atc-trigger (optional reveal button; if data-qp-atc-no-trigger is set on wrapper, hidden)
   *     .qp-atc-options
   *       .qp-atc-opt[data-qty="N"]  (one per quantity choice)
   *
   * Wrapper data attributes:
   *   data-qp-atc-variant-id    (optional, defaults to DEFAULT_VARIANT_ID)
   *   data-qp-atc-label-adding  (text shown while adding, default "Adding...")
   */
  function initATC(wrap) {
    if (wrap.dataset.qpAtcInited) return;
    wrap.dataset.qpAtcInited = '1';

    var trigger = wrap.querySelector('[data-qp-atc-trigger], .qp-atc-trigger, .qp-iwant-trigger');
    var opts = wrap.querySelector('[data-qp-atc-options], .qp-atc-options, .qp-iwant-options');
    if (!opts) return;
    var optButtons = $$('[data-qty]', opts);
    var variantId = parseInt(wrap.dataset.qpAtcVariantId, 10) || DEFAULT_VARIANT_ID;
    var labelAdding = wrap.dataset.qpAtcLabelAdding || 'Adding...';

    // Trigger reveal (if present and not hidden via data-qp-atc-no-trigger)
    if (trigger && !wrap.hasAttribute('data-qp-atc-no-trigger')) {
      trigger.addEventListener('click', function () {
        trigger.style.display = 'none';
        opts.classList.add('visible');
        opts.style.display = opts.style.display === 'none' ? 'flex' : opts.style.display;
      });
    }

    // Click handler per option
    optButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.qty, 10);
        if (!qty) return;
        var originalText = btn.textContent;
        // Disable all options while loading
        optButtons.forEach(function (b) { b.disabled = true; });
        btn.textContent = labelAdding;

        addToCart(qty, variantId)
          .catch(function () { /* swallow, restore below */ })
          .then(function () {
            // Restore button labels and re-enable
            optButtons.forEach(function (b) {
              b.disabled = false;
              if (b === btn) b.textContent = originalText;
            });
            // Re-collapse if trigger pattern is in use
            if (trigger && !wrap.hasAttribute('data-qp-atc-no-trigger')) {
              opts.classList.remove('visible');
              if (opts.style.display === 'flex') opts.style.display = 'none';
              trigger.style.display = '';
            }
          });
      });
    });
  }

  /**
   * Initialise lazy-loading + autoplay for videos with [data-qp-lazy-video].
   * Source URLs live on `<source data-src>`.
   * Plays when 25% visible, pauses when out of view.
   */
  function initLazyVideos(root) {
    if (!('IntersectionObserver' in window)) return;
    var videos = $$('video[data-qp-lazy-video]', root);
    if (!videos.length) return;

    function loadVideo(video) {
      if (video.dataset.qpLoaded) return;
      video.dataset.qpLoaded = '1';
      $$('source[data-src]', video).forEach(function (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      video.load();
    }

    var preloadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          preloadObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    var playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video);
          if (video.hasAttribute('data-qp-autoplay')) {
            video.play().catch(function () {});
          }
        } else {
          if (video.hasAttribute('data-qp-autoplay')) video.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (v) {
      preloadObserver.observe(v);
      playObserver.observe(v);
    });
  }

  /**
   * Initialise click-to-load for videos with [data-qp-click-video].
   * Loads on first user interaction (button or wrap click).
   */
  function initClickVideos(root) {
    var wraps = $$('[data-qp-click-video]', root);
    wraps.forEach(function (wrap) {
      if (wrap.dataset.qpClickInited) return;
      wrap.dataset.qpClickInited = '1';
      var video = wrap.querySelector('video');
      if (!video) return;
      var btn = wrap.querySelector('[data-qp-video-toggle]') || wrap;

      function ensureLoaded() {
        if (video.dataset.qpLoaded) return;
        video.dataset.qpLoaded = '1';
        $$('source[data-src]', video).forEach(function (s) {
          s.src = s.dataset.src;
          s.removeAttribute('data-src');
        });
        video.load();
      }

      function toggle(e) {
        if (e) e.stopPropagation();
        ensureLoaded();
        video.paused ? video.play() : video.pause();
      }

      if (btn !== wrap) btn.addEventListener('click', toggle);
      wrap.addEventListener('click', toggle);
    });
  }

  /**
   * Initialise dynamic collage qp-iwant injection.
   * Replaces a target collage button with the qp-iwant component.
   *
   * Triggered by element [data-qp-collage-iwant] containing JSON config:
   *   { trigger, opt1, opt2, adding, target_selector }
   */
  function initCollageInjection(root) {
    var configElems = $$('[data-qp-collage-iwant]', root);
    configElems.forEach(function (cfgEl) {
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      if (!cfg || !cfg.target_selector) return;

      function inject() {
        var target = document.querySelector(cfg.target_selector);
        if (!target || target.dataset.qpReplaced) return;

        var wrap = document.createElement('div');
        wrap.className = 'qp-iwant-wrap';
        wrap.style.cssText = 'display:flex;flex-direction:column;gap:10px;margin-top:8px;';
        wrap.setAttribute('data-qp-atc', '');
        wrap.setAttribute('data-qp-atc-no-trigger', '');
        wrap.setAttribute('data-qp-atc-label-adding', cfg.adding || 'Adding...');
        wrap.innerHTML =
          '<button class="qp-iwant-btn qp-iwant-trigger" type="button" style="display:none;">' + escapeHtml(cfg.trigger || '') + ' &nbsp;&#8594;</button>' +
          '<div class="qp-iwant-options qp-atc-options" style="display:flex;flex-direction:column;gap:8px;">' +
          '<button class="qp-iwant-btn qp-iwant-btn--sub qp-iwant-opt qp-atc-opt" data-qty="2" type="button">' + escapeHtml(cfg.opt2 || '') + '</button>' +
          '</div>';

        target.parentNode.replaceChild(wrap, target);
        target.dataset.qpReplaced = '1';
        initATC(wrap);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { inject(); setTimeout(inject, 1000); });
      } else {
        inject();
        setTimeout(inject, 1000);
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /**
   * Complimentary bonus rows (snippets/cart-bonuses.liquid).
   *
   * One-way activation: the green transition runs client-side immediately,
   * then the cart attribute is persisted WITHOUT a section re-render so the
   * animation is not interrupted. Later drawer re-renders restore the state
   * from cart.attributes in liquid.
   */
  function activateBonus(btn) {
    if (btn.dataset.active === 'true' || btn.dataset.qpBonusBusy) return;
    btn.dataset.qpBonusBusy = '1';
    btn.classList.add('qp-bonus--on');
    btn.setAttribute('aria-pressed', 'true');

    var attrs = {};
    attrs[btn.dataset.bonusAttr] = 'Activated';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      })
      .then(function () {
        btn.dataset.active = 'true';
      })
      .catch(function () {
        // Persisting failed — roll the row back so the UI does not lie.
        btn.classList.remove('qp-bonus--on');
        btn.setAttribute('aria-pressed', 'false');
      })
      .then(function () {
        delete btn.dataset.qpBonusBusy;
      });
  }

  /**
   * Theme-editor-only reset, driven by the cart-drawer section setting
   * "Reset activated bonuses" (qp_reset_bonuses). While checked, the snippet
   * renders #qp-bonuses-reset-flag (design mode only); detecting it here
   * clears all bonus attributes and re-renders the drawer so the rows return
   * to their gray inactive state for re-testing the activation animation.
   */
  var bonusResetBusy = false;

  function resetBonuses() {
    if (bonusResetBusy) return;
    bonusResetBusy = true;

    var drawerEl = document.getElementById('CartDrawer');
    var sectionId = drawerEl ? drawerEl.dataset.sectionId : null;
    var body = {
      attributes: {
        '1-Year Warranty': '',
        'Priority Customer Service': '',
        'Priority Order Processing': ''
      }
    };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && sectionId && data.sections[sectionId]) {
          renderDrawerSection(data.sections[sectionId], sectionId);
        } else {
          // No section payload — flip the rows back client-side instead.
          $$('.qp-bonus').forEach(function (row) {
            row.classList.remove('qp-bonus--on');
            row.dataset.active = 'false';
            row.setAttribute('aria-pressed', 'false');
          });
        }
      })
      .catch(function () { /* leave as-is on network error */ })
      .then(function () {
        bonusResetBusy = false;
      });
  }

  function maybeEditorResetBonuses() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    if (document.getElementById('qp-bonuses-reset-flag')) resetBonuses();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var bonus = e.target.closest('.qp-bonus');
    if (bonus) activateBonus(bonus);
  });

  function initAll(root) {
    $$('[data-qp-atc]', root).forEach(initATC);
    initLazyVideos(root);
    initClickVideos(root);
    initCollageInjection(root);
    maybeEditorResetBonuses();
  }

  // Auto-init on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-init on Shopify theme editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Expose for debugging / manual triggering
  window.QuickPlateCart = {
    addToCart: addToCart,
    initAll: initAll,
    initATC: initATC,
    activateBonus: activateBonus,
  };
})();

